export default "__VITE_ASSET__bbcced74__"